import { useOnboardingLock } from "@/features/onboarding-lock"
import { usePalmistryContext } from "@/features/webapp"

import { ReportIds, type ReportId } from "../config/reports-data"

/**
 * Same badge sources as the tabbar (`WebappNav`): palmistry prefers the 10‑min
 * scan lock, else the onboarding 30‑min lock; compatibility uses onboarding only.
 */
export function useTabReportTimerLabel(reportId: ReportId): string | null {
  const { timeLeft } = usePalmistryContext()
  const { remainingLabel: onboardingTimeLeft, isLocked } = useOnboardingLock()

  if (reportId === ReportIds.Palmistry) {
    if (timeLeft !== null) return timeLeft
    if (isLocked("palmistry_tab")) return onboardingTimeLeft
    return null
  }

  if (reportId === ReportIds.Compatibility) {
    return isLocked("compatibility_tab") ? onboardingTimeLeft : null
  }

  return null
}
